import Background from "../../assets/img/jpg/background.jpg";
import styled from "styled-components";

export const StyledLayout = styled.div`
  width: 100vw;
  height: 100vh;
  background-image: url(${Background});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;

export const ContentStyle = styled.div`
  width: 88%;
  flex: 1;
  margin-top: 14px;
  height: 100%;
  overflow: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

export const StyledPatientsListLayout = styled.div`
  background: white;
  border-top-left-radius: 7px;
  border-top-right-radius: 7px;
  height: 100%;
  overflow-y: auto;
`;
export const StyledTableWrapper = styled.div`
  background: #f1fbfc;
  min-height: 30rem;
  width: 100%; /* Ajout explicite */
  box-shadow: 0px 1.30033px 5.20132px rgba(0, 0, 0, 0.12);
  border-radius: 10.2177px;
  padding: 10px;
  flex-grow: 1;
  box-sizing: border-box; /* Pour éviter les décalages */
  overflow-y: scroll;

  &::-webkit-scrollbar {
    width: 8px;
    right: 5px;
    margin: 10px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 14.4896px;
    right: 5px;
    margin: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 14.4896px;
    right: 5px;
    margin: 10px;
  }
`;

export const StyledPatientsListTableWrapper = styled.div`
  width: 100%;
  padding: 2rem;
  background: white;
  border-top-left-radius: 7px;
  border-top-right-radius: 7px;
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column; /* Alignement vertical */
  align-items: stretch; /* Ajouté pour aligner les enfants */
  gap: 1rem;
  box-sizing: border-box;

  .title {
    font-family: "Ubuntu";
    font-style: normal;
    font-weight: 500;
    font-size: 35.0127px;
    line-height: 17px;
    display: flex;
    align-items: center;
    color: #50799e;
  }
`;

export const StyledLogo = styled.div`
  display: flex;
  align-items: center;
  margin-left: 10px;
  justify-content: center;
  gap: 20px;
  .titles {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 5px;
    .viseo {
      font-family: "Ubuntu";
      font-style: normal;
      font-weight: 500;
      font-size: 20.044px;
      line-height: 19px;
      color: #20a8d3;
    }
    .far {
      font-family: "Ubuntu";
      font-style: normal;
      font-weight: 500;
      font-size: 20.044px;
      line-height: 19px;
      color: #e5deaf;
    }
  }
`;

//

export const StyledDateContent = styled.span`
  margin-left: 10px;
  color: #50799e;
  font-size: 14px;
  font-family: Ubuntu;
  line-height: 18.564px;
  letter-spacing: -1px;
`;

export const StyledCalendarIcon = styled.img`
  width: 21px;
  height: 23.333px;
  flex-shrink: 0;
`;

export const StyledTimerIcon = styled.img`
  margin-left: 20px;
  width: 23px;
  height: 23px;
  flex-shrink: 0;
`;

export const StyledTimeContent = styled.span`
  color: #50799e;
  font-size: 18px;
  margin-left: 2px;
  font-family: Ubuntu;
  line-height: 18.564px;
  letter-spacing: -1px;
`;

export const StyledHeader = styled.div<{
  isLoginPage: boolean;
  animate: boolean;
}>`
  width: 88%;
  margin-top: ${(props) => (props.animate ? "-4rem" : "15px")};
  background: #ffffff;
  border-bottom-left-radius: 15px;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;
  display: flex;
  /* z-index: 200 !important; */
  align-items: center;
  justify-content: ${(props) =>
    !props.isLoginPage ? "space-between" : "center"};

  transition: margin-top 3s ease;
  &:hover {
    margin-top: 15px;
    transition: margin-top 1s ease;
  }
`;

// export const StyledHeader = styled.div<{ isLoginPage: boolean, animate: boolean }>`
// width: 88%;
//   margin-top: ${(props) => (props.animate ? '-4rem' : '15px')};
//   background: #ffffff;
//   border-bottom-left-radius: 15px;
//   border-top-left-radius: 15px;
//   border-top-right-radius: 15px;
//   border-bottom-right-radius: 15px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   transition: margin-top 3s ease;

//   &:hover {
//     margin-top: 15px;
//     transition: margin-top 1s ease;
//   }
// `;
